module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"subtotal":"Subtotal","total":"Total"}}')
  delete Component.options._Ctor
}
